import {
	UPLOAD_FILE_REQUEST,
	UPLOAD_FILE_REQUEST_SUCCESS,
	UPLOAD_FILE_REQUEST_FAILED,
	UPLOAD_FILE_REQUEST_CLEAR,
	UPLOAD_FILE_REQUEST_CLEAR_ALL,
	EXTRACT_FILE_REQUEST,
	EXTRACT_FILE_REQUEST_SUCCESS,
	EXTRACT_FILE_REQUEST_FAILED,
	EXTRACT_FILE_REQUEST_CLEAR_ALL,
	EXTRACT_FILE_REQUEST_CLEAR,
	KB_MAKING_TRIGGER_REQUEST,
	KB_MAKING_TRIGGER_REQUEST_CLEAR,
	KB_MAKING_TRIGGER_REQUEST_CLEAR_ALL,
	KB_MAKING_TRIGGER_REQUEST_FAILED,
	KB_MAKING_TRIGGER_REQUEST_SUCCESS,
	PII_EXTRACT_TRIGGER_REQUEST,
	PII_EXTRACT_TRIGGER_REQUEST_CLEAR,
	PII_EXTRACT_TRIGGER_REQUEST_FAILED,
	PII_EXTRACT_TRIGGER_REQUEST_SUCCESS,
	REVERT_PII_EXTRACT_REQUEST,
	REVERT_PII_EXTRACT_REQUEST_CLEAR,
	REVERT_PII_EXTRACT_REQUEST_FAILED,
	REVERT_PII_EXTRACT_REQUEST_SUCCESS,
	REVERT_TEXT_EXTRACT_REQUEST,
	REVERT_TEXT_EXTRACT_REQUEST_CLEAR,
	REVERT_TEXT_EXTRACT_REQUEST_FAILED,
	REVERT_TEXT_EXTRACT_REQUEST_SUCCESS,
	GET_UPLOAD_FILE_SUMMARY_REQUEST,
	GET_UPLOAD_FILE_SUMMARY_REQUEST_SUCCESS,
	GET_UPLOAD_FILE_SUMMARY_REQUEST_FAILED,
	GET_UPLOAD_FILE_SUMMARY_REQUEST_CLEAR,
	DELETE_CASE_REQUEST,
	DELETE_CASE_REQUEST_SUCCESS,
	DELETE_CASE_REQUEST_FAILED,
	DELETE_CASE_REQUEST_CLEAR,
	CHANGE_CASE_MODE_REQUEST,
	CHANGE_CASE_MODE_REQUEST_SUCCESS,
	CHANGE_CASE_MODE_REQUEST_FAILED,
	CHANGE_CASE_MODE_REQUEST_CLEAR,
	POST_BIFROST_JOB_REQUEST,
	POST_BIFROST_JOB_REQUEST_SUCCESS,
	POST_BIFROST_JOB_REQUEST_FAILED,
	POST_BIFROST_JOB_REQUEST_RESET,
} from "../types"

const initialState = {
	upload: [],
	isUploading: false,
	extract: [],
	isExtracting: false,
	kbMaking: [],
	isKbMakingLoading: false,
	PiiExtract: [],
	isPiiExtractLoading: false,
	isUploadFileSummaryLoading: false,
	uploadFileSummaryDetails: {},
	uploadFileSummaryDetailsError: "",
	isDeleteCaseLoading: false,
	isCaseDeleted: false,
	deleteCaseDetailsError: "",
	isRevertPiiExtractLoading: false,
	isRevertPiiExtractLoaded: false,
	isRevertTextExtractLoading: false,
	isRevertTextExtractLoaded: false,
	isChangeCaseModeLoading: false,
	isCaseModeChanged: false,
	isBifrostJobLoading: false,
	isBifrostJobLoaded: false,
}

const bifrostCaseReducer = (state = initialState, action) => {
	switch (action.type) {
		case UPLOAD_FILE_REQUEST:
			let request = { ...state.upload }
			request[action.payload.case_id] = { upload: action.payload, isUploading: true, isUploaded: false }
			return {
				...state,
				upload: request,
				isUploading: true,
			}
		case UPLOAD_FILE_REQUEST_SUCCESS:
			let response = { ...state.upload }
			response[action.payload.case_id] = { upload: action.payload, isUploading: false, isUploaded: true }
			return {
				...state,
				upload: response,
				isUploading: false,
			}
		case UPLOAD_FILE_REQUEST_FAILED:
			let error = { ...state.upload }
			error[action.payload.case_id] = { error: action.payload.error, isUploading: false, isUploaded: false }
			return {
				...state,
				upload: error,
				isUploading: false,
			}
		case UPLOAD_FILE_REQUEST_CLEAR:
			let clear = { ...state.upload }
			let data = clear[action.payload] //remove specific case from upload list
			data.isUploading = false
			data.isUploaded = false
			data.error = undefined
			return {
				...state,
				upload: data,
			}
		case UPLOAD_FILE_REQUEST_CLEAR_ALL:
			return {
				...state,
				error: undefined,
				upload: [],
			}
		case EXTRACT_FILE_REQUEST:
			let req = { ...state.extract }
			req[action.payload.case_id] = { extract: action.payload, isExtracting: true, isExtracted: false }
			return {
				...state,
				extract: req,
				isExtracting: true,
			}
		case EXTRACT_FILE_REQUEST_SUCCESS:
			let res = { ...state.extract }
			res[action.payload.case_id] = { extract: action.payload, isExtracting: false, isExtracted: true }
			return {
				...state,
				extract: res,
				isExtracting: false,
			}
		case EXTRACT_FILE_REQUEST_FAILED:
			let err = { ...state.extract }
			err[action.payload.case_id] = { error: action.payload.error, isExtracting: false, isExtracted: false }
			return {
				...state,
				extract: err,
				isExtracting: false,
			}
		case EXTRACT_FILE_REQUEST_CLEAR:
			let clr = { ...state.extract }
			let clrData = clr[action.payload] //remove specific case from extract list
			clrData.isExtracting = false
			clrData.isExtracted = false
			clrData.error = undefined
			return {
				...state,
				extract: clrData,
			}
		case EXTRACT_FILE_REQUEST_CLEAR_ALL:
			return {
				...state,
				error: undefined,
				extract: [],
			}

		case KB_MAKING_TRIGGER_REQUEST:
			let kbRequest = { ...state.kbMaking }
			kbRequest[action.payload.case_id] = { kbMaking: action.payload, isKbMakingLoading: true, isKbMakingDone: false }
			return {
				...state,
				kbMaking: kbRequest,
				isKbMakingLoading: true,
			}
		case KB_MAKING_TRIGGER_REQUEST_SUCCESS:
			let kbResponse = { ...state.kbMaking }
			kbResponse[action.payload.case_id] = {
				kbMaking: action.payload,
				isKbMakingLoading: false,
				isKbMakingDone: true,
			}
			return {
				...state,
				kbMaking: kbResponse,
				isKbMakingLoading: false,
			}
		case KB_MAKING_TRIGGER_REQUEST_FAILED:
			let kbError = { ...state.kbMaking }
			kbError[action.payload.case_id] = {
				kbError: action.payload.error,
				isKbMakingLoading: false,
				isKbMakingDone: false,
			}
			return {
				...state,
				kbMaking: kbError,
				isKbMakingLoading: false,
			}
		case KB_MAKING_TRIGGER_REQUEST_CLEAR:
			let kbClear = { ...state.kbMaking }
			let kbData = kbClear[action.payload] //remove specific case from kbMaking list
			kbData.isKbMakingLoading = false
			kbData.isKbMakingDone = false
			kbData.error = undefined
			return {
				...state,
				kbMaking: kbData,
			}
		case KB_MAKING_TRIGGER_REQUEST_CLEAR_ALL:
			return {
				...state,
				error: undefined,
				kbMaking: [],
			}

		case GET_UPLOAD_FILE_SUMMARY_REQUEST:
			return {
				...state,
				uploadFileSummaryDetails: {},
				isUploadFileSummaryLoading: true,
			}

		case GET_UPLOAD_FILE_SUMMARY_REQUEST_SUCCESS:
			return {
				...state,
				uploadFileSummaryDetails: action.payload,
				isUploadFileSummaryLoading: false,
			}

		case GET_UPLOAD_FILE_SUMMARY_REQUEST_FAILED:
			return {
				...state,
				uploadFileSummaryDetailsError: action.payload.error,
				isUploadFileSummaryLoading: false,
			}

		case GET_UPLOAD_FILE_SUMMARY_REQUEST_CLEAR:
			return {
				...state,
				uploadFileSummaryDetails: {},
				uploadFileSummaryDetailsError: "",
				isUploadFileSummaryLoading: false,
			}

		case DELETE_CASE_REQUEST:
			return {
				...state,
				isDeleteCaseLoading: true,
			}

		case DELETE_CASE_REQUEST_SUCCESS:
			return {
				...state,
				isCaseDeleted: true,
				isDeleteCaseLoading: false,
			}

		case DELETE_CASE_REQUEST_FAILED:
			return {
				...state,
				isCaseDeleted: false,
				deleteCaseDetailsError: action.payload.error,
				isDeleteCaseLoading: false,
			}

		case DELETE_CASE_REQUEST_CLEAR:
			return {
				...state,
				isCaseDeleted: false,
				deleteCaseDetailsError: "",
				isDeleteCaseLoading: false,
			}
		case CHANGE_CASE_MODE_REQUEST:
			return {
				...state,
				isChangeCaseModeLoading: true,
			}

		case CHANGE_CASE_MODE_REQUEST_SUCCESS:
			return {
				...state,
				isCaseModeChanged: true,
				isChangeCaseModeLoading: false,
			}

		case CHANGE_CASE_MODE_REQUEST_FAILED:
			return {
				...state,
				isCaseModeChanged: false,
				ChangeCaseModeError: action.payload.error,
				isChangeCaseModeLoading: false,
			}

		case CHANGE_CASE_MODE_REQUEST_CLEAR:
			return {
				...state,
				isCaseModeChanged: false,
				ChangeCaseModeError: "",
				isChangeCaseModeLoading: false,
			}
		case PII_EXTRACT_TRIGGER_REQUEST:
			return {
				...state,
				isPiiExtractLoading: true,
			}

		case PII_EXTRACT_TRIGGER_REQUEST_SUCCESS:
			return {
				...state,
				isPiiExtractLoaded: true,
				isPiiExtractLoading: false,
			}

		case PII_EXTRACT_TRIGGER_REQUEST_FAILED:
			return {
				...state,
				isPiiExtractLoaded: false,
				piiExtractError: action.payload.error,
				isPiiExtractLoading: false,
			}

		case PII_EXTRACT_TRIGGER_REQUEST_CLEAR:
			return {
				...state,
				piiExtractError: "",
				isPiiExtractLoading: false,
			}
		case REVERT_PII_EXTRACT_REQUEST:
			return {
				...state,
				isRevertPiiExtractLoading: true,
			}

		case REVERT_PII_EXTRACT_REQUEST_SUCCESS:
			return {
				...state,
				isRevertPiiExtractLoaded: true,
				isRevertPiiExtractLoading: false,
			}

		case REVERT_PII_EXTRACT_REQUEST_FAILED:
			return {
				...state,
				isRevertPiiExtractLoaded: false,
				revertPiiExtractError: action.payload.error,
				isRevertPiiExtractLoading: false,
			}

		case REVERT_PII_EXTRACT_REQUEST_CLEAR:
			return {
				...state,
				revertPiiExtractError: "",
				isRevertPiiExtractLoading: false,
			}
		case REVERT_TEXT_EXTRACT_REQUEST:
			return {
				...state,
				isRevertTextExtractLoading: true,
			}

		case REVERT_TEXT_EXTRACT_REQUEST_SUCCESS:
			return {
				...state,
				isRevertTextExtractLoaded: true,
				isRevertTextExtractLoading: false,
			}

		case REVERT_TEXT_EXTRACT_REQUEST_FAILED:
			return {
				...state,
				isRevertTextExtractLoaded: false,
				revertTextExtractError: action.payload.error,
				isRevertTextExtractLoading: false,
			}

		case REVERT_TEXT_EXTRACT_REQUEST_CLEAR:
			return {
				...state,
				revertTextExtractError: "",
				isRevertTextExtractLoading: false,
			}
		case POST_BIFROST_JOB_REQUEST:
			return {
				...state,
				isBifrostJobLoading: true,
			}
		case POST_BIFROST_JOB_REQUEST_SUCCESS:
			return {
				...state,
				isBifrostJobLoading: false,
				isBifrostJobLoaded: true,
			}
		case POST_BIFROST_JOB_REQUEST_FAILED:
			return {
				...state,
				postBifrostJobError: action.payload.error,
				isBifrostJobLoading: false,
				isBifrostJobLoaded: false,
			}
		case POST_BIFROST_JOB_REQUEST_RESET:
			return {
				...state,
				postBifrostJobError: "",
				isBifrostJobLoading: false,
				isBifrostJobLoaded: false,
			}
		default:
			return state
	}
}

export default bifrostCaseReducer
